enum CardType {
  CONTACT = 'contact',
  FOOTER = 'footer',
}
export default CardType;
